import {AuthRoute} from '@common/auth/guards/auth-route';
import {useAuth} from '@common/auth/use-auth';
import {ActiveWorkspaceProvider} from '@common/workspace/active-workspace-id-context';
import {Navigate, RouteObject} from 'react-router';

/**
 * The drive, unless you are a dealer.
 *
 * A dealer owns no organization, so there is no storage pool behind this and
 * nothing they could put in it - they would land on an empty drive with a
 * storage meter reading nothing. Sending them to the customer list they came
 * to manage is more useful than showing them a cupboard they cannot fill.
 *
 * Not a permission check: the drive requires none, it is simply home for
 * everyone who stores files, and a dealer is the one account type that does
 * not.
 */
function DriveOrManageArea() {
  const {user} = useAuth();
  if (user?.dealer_id) {
    return <Navigate to="/admin/organizations" replace />;
  }
  return <AuthRoute />;
}

export const driveRoutes: RouteObject[] = [
  {
    path: 'drive',
    element: (
      <ActiveWorkspaceProvider>
        <DriveOrManageArea />
      </ActiveWorkspaceProvider>
    ),
    children: [
      {
        index: true,
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'folders/:hash',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'shares',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'recent',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'starred',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'trash',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'search',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
    ],
  },
  {
    path: 'drive/s/:hash',
    lazy: () =>
      import(
        '@app/drive/shareable-link/shareable-link-page/shareable-link-page'
      ),
  },
];
